<script setup lang="ts">
import type { EsFilterDefaultFragment } from '#graphql-operations'

// const { t: $t } = useI18n()

const props = defineProps<{
  filter: EsFilterDefaultFragment
}>()

const meta = inject('meta', ref())

const {
  optionToggle,
  rangeUpdate,
  filterApply,
  filterRemove,
  filtersApplyAll,
  getExpectedTotal,
} = useCatalogFilters(meta)

const isCategoryFilter = computed<boolean>(() => {
  return ['cat', 'category'].includes(props.filter.key)
})

const isExpanded = computed<boolean>(() => {
  return !!props.filter.isExpanded || isCategoryFilter.value
})

const range = (filterKey: string, min: number, max: number) => {
  rangeUpdate(filterKey, min, max)
  getExpectedTotal()
}

function toggle(filterKey: string, optionKey: string) {
  optionToggle(filterKey, optionKey)
  getExpectedTotal()
}

function filterApplyAndUpdate(filterKey: string) {
  filterApply(filterKey)
  filtersApplyAll()
}

function filterResetAndUpdate(filterKey: string) {
  filterRemove(filterKey) // Empty all active option in this filter
  getExpectedTotal()
  filtersApplyAll()
}
</script>

<template>
  <UiCollapsable
    class="filter-item"
    :active="filter.activeOptionsCount"
    :reference="filter.key"
    :label="filter.label"
    :open="isExpanded"
  >
    <template #label="{ open }">
      <span>
        {{ $t(filter.label) }}
      </span><!-- This data comes from Magento, can we try to fix the translation there? -->

      <template v-if="!isCategoryFilter">
        <span
          v-if="filter.activeOptionsCount"
          class="filter-item__count"
        >{{ filter.activeOptionsCount }}</span>
      </template>

      <NuxtIcon
        v-if="open"
        name="icon:min"
      />
      <NuxtIcon
        v-else
        name="icon:plus"
      />
    </template>

    <LazyFilterLinks
      v-if="isCategoryFilter"
      :filter="filter"
    />
    <LazyFilterRange
      v-else-if="filter.type === 'range' /* && filter.key === 'f__price'*/"
      :filter="filter"
      @filter-reset="filterResetAndUpdate(filter.key)"
      @filter-apply="filterApplyAndUpdate(filter.key)"
      @update="(data) => range(filter.key, data.min, data.max)"
    />
    <LazyFilterOptions
      v-else-if="filter.type === 'default' || filter.type === 'visual'"
      :filter="filter"
      @option-toggle="(optionKey: string) => toggle(filter.key, optionKey)"
      @filter-reset="filterResetAndUpdate(filter.key)"
      @filter-apply="filterApplyAndUpdate(filter.key)"
    />
    
  </UiCollapsable>
</template>

<style>
@import url("~layers/components/Filter/Item.css");
</style>
